/** ******** 控销团队管理   ********** */
// 控销团队列表查询
export const getControlSalesTeamList = {
  url: '/admin/supplier/getSup.json',
  method: 'get'
};

// 效验是否能导出列表
export const getSupplierMerCount = {
  url: '/admin/supplier/getSupplierMerCount.json',
  method: 'get'
};

// 团队列表导出
export const exportTeamList = {
  url: '/admin/supplier/exportSupplierDetail.json'
};

// 获取团队类型
export const getCatalog = {
  url: '/admin/common/getCatalog.json',
  method: 'get'
};

// 获取发货方信息
export const getDistributorList = {
  url: '/admin/branch/queryBranchInfo.json',
  method: 'get'
};

// 新增或编辑控销团队
export const mergeSupplier = {
  url: '/admin/supplier/mergeSupplier',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

export const getEditDistributorList = {
  url: '/admin/branch/queryBranch4Supplier.json',
  method: 'get'
};

// 获取订单品种列表
export const getOrderauditMerchandise = {
  url: '/admin/supplier/getOrderauditMerchandise.json',
  method: 'get'
};

// 获取无需审核客户列表
export const getOrderCustomer = {
  url: '/admin/supplier/getOrderCustomer.json',
  method: 'get'
};

// 获取订单金额详情
export const getAuditPriceId = {
  url: '/admin/supplier/getAuditPriceId.json',
  method: 'get'
};
// ******* 订单审核模块
// 获取人员审核列表
export const getOrderAuditDivId = {
  url: '/admin/supplier/getOrderAuditDivId.json',
  method: 'get'
};

// 保存订单审核详情
export const updateOrderAutidDivId = {
  url: '/admin/supplier/updateOrderAutidDivId.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 获取业需要添加到审核人的 业务员列表
export const getSalesmanBySupplierId = {
  url: '/admin/supplier/getSalesmanBySupplierId.json',
  method: 'get'
};

// 添加审核人员
export const createOrderauditMain = {
  url: '/admin/supplier/createOrderauditMain.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 删除人员审核记录
export const deleteByAuditMainId = {
  url: '/admin/supplier/deleteByAuditMainId.json',
  method: 'post'
};

// 查询人员审核表格数据
export const getPersonnelReview = {
  url: '/admin/supplier/getPersonnelReview.json',
  method: 'get'
};

// 修改审核人员表格
export const updateOrderauditMain = {
  url: '/admin/supplier/updateOrderauditMain.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 获取药品列表发货方下拉
export const getTheSupBranch = {
  url: '/admin/supplier/getTheSupBranch.json',
  method: 'post'
};

// 获取商品列表
export const getDrugInformation = {
  url: '/admin/supplier/getDrugInformation.json',
  method: 'get'
};

// 添加商品到订单品种
export const insertOrderAutidDivId = {
  url: '/admin/supplier/insertOrderAutidDivId.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 获取客户列表
export const getCustInformation = {
  url: '/admin/supplier/getCustInformation.json',
  method: 'get'
};

// 添加到无需审核客户列表
export const insertOrderCustomer = {
  url: '/admin/supplier/insertOrderCustomer.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 删除订单品种
export const deleteOrderAutidDivId = {
  url: '/admin/supplier/deleteOrderAutidDivId.json',
  method: 'post'
};

// 删除无需审核客户
export const deleteOrderCustomer = {
  url: '/admin/supplier/deleteOrderCustomer.json',
  method: 'post'
};

// 导入无需审核客户
export const execlImportCustomer = {
  url: '/admin/supplier/execlImportCustomer'
};

// ********** 控销团队 业务管理模块
// 组织结构信息获取
export const getStructureTreeInfo = {
  url: '/admin/structure/getStructureTreeInfo.json',
  method: 'get'
};

// 获取业务区域选择列表
export const getBusiAreeTree = {
  url: '/admin/structure/getBusiAreeTree.json',
  method: 'get',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 新增团队
export const addNextDeptInfo = {
  url: '/admin/structure/addNextDeptInfo.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 编辑团队
export const editSaveDeptInfo = {
  url: '/admin/structure/editSaveDeptInfo.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 删除团队
export const deleteDept = {
  url: '/admin/structure/deleteDept.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 获取药品分类列表
export const getCategoryList = {
  url: '/admin/supplier/getMerType',
  method: 'get'
};

// 维护/删除 药品分类
export const updateDrugsCategory = {
  url: '/admin/supplier/updateSupMerType',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 新增/编辑 分类
export const saveCategory = {
  url: '/admin/supplier/saveMerType',
  method: 'post'
};

// 分类排序
export const sortCategory = {
  url: '/admin/supplier/saveMerTypeSort',
  method: 'post'
};

// 删除分类
export const delCategory = {
  url: '/admin/supplier/deleteMerType',
  method: 'post'
};

// 可售药品列表
export const sellingDrugsList = {
  url: '/admin/supplier/getSupMer',
  method: 'get'
};

// 导入药品列表
export const uploadMerchandiseInfo = {
  url: '/admin/supplier/uploadMerchandiseInfo'
};

// 添加药品列表
export const getMerchandis4Sup = {
  url: '/admin/supplier/getMerchandis4Sup',
  method: 'get'
};

// 获取发货方
export const getBranchSource = {
  url: '/admin/supplier/getBranchSource',
  method: 'get'
};

// 添加药品
export const addSupMer = {
  url: '/admin/supplier/addSupMer',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 删除药品
export const deleteSupMer = {
  url: '/admin/supplier/deleteSupMer',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 获取关联人员列表
export const getUserInfoByStructureId = {
  url: '/admin/structure/getUserInfoByStructureId.json',
  method: 'get'
};

export const getSalesmanListBySupplierId = {
  url: '/admin/structure/getSalesmanListBySupplierId.json',
  method: 'get'
};

export const saveSalesmanRelation = {
  url: '/admin/structure/saveSalesmanRelation.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

export const removeRelation = {
  url: '/admin/structure/removeRelation.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 导出关联人员列表
export const exportUserInfo = {
  url: '/admin/structure/exportUserInfoAsync.json'
};

// 获取业务区域
export const getSalesManAreeTree = {
  url: '/admin/structure/getSalesManAreeTree.json',
  method: 'get'
};

// 编辑业务区域
export const saveSalesmanArea = {
  url: '/admin/structure/saveSalesmanArea.json',
  method: 'post'
};
// 关联销售团队
export const relateTeam = {
  url: '/admin/structure/relationSaleSupplier.json',
  method: 'post'
};
// 获取销售团队配送配置
export const getSupplierDeliveryConfig = {
  url: '/admin/supplierConfig/getSupplierConfig.json',
  method: 'get'
};
// 保存销售团队配送配置
export const saveSupplierDeleveryConfig = {
  url: '/admin/supplierConfig/saveSupplierDeliveryConfig.json',
  method: 'post'
};
// 保存团队配置-业务员开票方式
export const saveSupplierInvoiceConfig = {
  url: '/admin/supplierConfig/saveSupplierInvoiceConfig.json',
  method: 'post'
};
// 保存团队配置-货主库存
export const saveSupplierOwnerConfig = {
  url: '/admin/supplierConfig/saveSupplierOwnerConfig.json',
  method: 'post'
};
// 省总相关标记
export const changeUserIdentify = {
  url: '/admin/structure/changeUserIdentity.json',
  method: 'post'
};
// 搜索团队关联的分销商货主列表
export const searchBranchOwnerInfoList = {
  url: '/admin/supplierConfig/searchBranchOwnerInfoList.json',
  method: 'get'
};
// 共享团队设置积分列表
export const getSupplierMerchandiseIntegraList = {
  url: '/admin/supplierIntegral/getSupplierMerchandiseIntegralList.json',
  method: 'get'
};
// 共享团队-设置积分
export const saveMerchandiseIntegralConfig = {
  url: '/admin/supplierIntegral/saveMerchandiseIntegralConfig.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};
// 共享团队-查看关系网
export const getSalesmanInvitationRelation = {
  url: '/admin/supplier/getSalesmanInvitationRelationInfo.json',
  method: 'get'
};

// 设置团队商品底价
export const updateBottomPrice = {
  url: '/admin/supplier/editPrice',
  method: 'post'
};

// 全国区域数
export const getSysAreaTree = {
  url: '/basic/getSysAreaTree.json',
  method: 'get'
}

// 获取团队用户流向权限配置详情
export const getBillAuth = {
  url: '/admin/structure/supUserBillAuthQuery.json',
  method: 'get'
}
// 保存团队用户流向权限配置
export const saveBillAuth = {
  url: '/admin/structure/saveUserBillAuth.json',
  method: 'post'
}
// 保存订单审核
export const saveOrderAuditInfo = {
  url: '/admin/supplier/orderAudit/saveOrderAuditInfo.json',
  method: 'post'
}
// 获取订单审核信息
export const getOrderAuditInfo = {
  url: '/admin/supplier/orderAudit/getOrderAuditInfo.json',
  method: 'get'
}
// 审核人
export const getAuditPerson = {
  url: '/admin/supplier/orderAudit/getSalesmanBySupplierId.json',
  method: 'get'
}
// 获取价格同步配置
export const getSupPriceStrategy = {
  url: '/admin/supplier/getSupPriceSyncStrategy',
  method: 'get'
}
export const setSupPriceStrategy = {
  url: '/admin/supplier/setSupPriceSyncStrategy',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
}
export const saveCancerOrderConfig = {
  url: '/admin/supplierConfig/saveSupplierOrderCancelStatus.json',
  method: 'post'
}
export const saveDynamicBusinessMenuStatus = {
  url: '/admin/supplierConfig/saveSupplierDynamicBusinessStatus.json',
  method: 'post'
}
export const saveCustOrderCheck = {
  url: '/admin/supplierConfig/saveSupplierOverdueCustOrderCheck.json',
  method: 'post'
}
// 设置团队进货价和销售价
export const updateTeamPrice = {
  url: '/admin/supplier/merchandise/editTeamPrice',
  method: 'post'
};

// 查询禁用品种可售业务员列表
export const getCanSalesmanListBySupplierId = {
  url: '/admin/supplier/getCanSalesmanListBySupplierId.json',
  method: 'get'
};

// 保存禁用品种可售业务员列表
export const deleteCanSalesmanListBySupplierId = {
  url: '/admin/supplier/deleteCanSalesmanListBySupplierId.json',
  method: 'post'
};

// 查询禁用品种可选可售业务员列表
export const getCanSalesmanChooseListBySupplierId = {
  url: '/admin/supplier/getCanSalesmanChooseListBySupplierId.json',
  method: 'get'
};

// 保存禁用品种可售业务员列表
export const saveCanSalesmanListBySupplierId = {
  url: '/admin/supplier/saveCanSalesmanListBySupplierId.json',
  method: 'post'
};

// 保存业务员商品新增购买数量
export const saveCanSalesmanCountById = {
  url: '/admin/supplier/saveCanSalesmanCountById.json',
  method: 'post'
};


// 校验商品是否为超值换购活动赠品
export const checkProdMzGiftBySupplierId = {
  url: '/admin/supplier/checkProdMzGift.json',
  method: 'post'
};
